<dx-data-grid *ngIf="productTechicalFeatures && technicalFeatures "  #features [addOptions]="['addTechnicalfeatureGroup', 'addTechnicalfeature']"
(editorComponentClosed)="onFeaturesDataSourceChange($event)"
[createComponent]="technicalFeatureAdd" [customParams]="{ id:product!.id }"
[glamResource]="productTechicalFeatures!">
<dxo-editing class="hidden" [allowUpdating]="true"></dxo-editing>
<dxi-column name="code" [caption]="'common.code' | translate | ucfirst" dataField="technicalFeatureId" dataType="string"
  [allowEditing]="false">
  <dxo-lookup [dataSource]="technicalFeatures" displayExpr="code" valueExpr="id" />
</dxi-column>
<dxi-column name="name" [caption]="'common.name' | translate | ucfirst" dataField="technicalFeatureId" dataType="string"
  [allowEditing]="false">
  <dxo-lookup [dataSource]="technicalFeatures" displayExpr="name" valueExpr="id" />
</dxi-column>
<dxi-column name="valueTypeId" [caption]="'entity.technicalFeature.valueTypeId' | translate | ucfirst" dataField="technicalFeatureId" dataType="string"
  [allowEditing]="false">
  <dxo-lookup [dataSource]="technicalFeatures" displayExpr="valueTypeName" valueExpr="id" />
</dxi-column>
<dxi-column  width="200px" editCellTemplate="editTechnicalFeatureValue" [caption]="'common.value' | translate | ucfirst"
  dataField="value" dataType="string" />
<div *dxTemplate="let row of 'editTechnicalFeatureValue'" style="display: flex; overflow-x: auto;">

  <dx-number-box
    [(value)]="row.value"
    *ngIf="technicalFeaturesRowIsValueType(1, row)" (onValueChanged)="technicalFeaturesRowSetValue(1, row)"
    />
    <dx-text-box
    [(value)]="row.value"
    *ngIf="technicalFeaturesRowIsValueType(2, row)"
    (onValueChanged)="technicalFeaturesRowSetValue(2, row)"
    (onFocusOut)="onFeaturesSaving(row)"

  >
  </dx-text-box>
  <dx-text-box
    [(value)]="row.value"
    *ngIf="technicalFeaturesRowIsValueType(3, row)" (onValueChanged)="technicalFeaturesRowSetValue(3, row)"
    />
  <dx-select-box
    [(value)]="row.value"
    *ngIf="technicalFeaturesRowIsValueType(4, row)" (onValueChanged)="technicalFeaturesRowSetValue(4, row)"
    (onFocusIn)="getTechnicalfeaturesValues(row)"
    [items]="this.technicalfeaturesValues" displayExpr="display" valueExpr="value"
    />
  <dx-tag-box #tagBox
    [(value)]="onInitTagBoxValue"
    *ngIf="technicalFeaturesRowIsValueType(5, row)"
    (onFocusIn)="tagBoxValues(row)"
    [items]="this.technicalfeaturesValues" valueExpr="value" displayExpr="display"
    [scrollable]="true" [multiline]="false" width="200"
  />
</div>
</dx-data-grid>